import { useCallback } from "react";
import { useFinancialDocumentBulkSelection } from "@components/documents/FinancialDocumentBulkSelection/useFinancialDocumentBulkSelection";
import { AddToChatButton } from "../../AddToChatButton";
import { useAddDocumentsToChat } from "../../useAddDocumentsToChat";

const SELECT_ALL_DISABLED_REASON =
    "Select documents individually to add them to chat";

export const FinancialDocumentsTaskAskButton: React.FC = () => {
    const bulkSelection = useFinancialDocumentBulkSelection();
    const { canAddToChat, addDocumentsToChat } = useAddDocumentsToChat();

    const handleAttach = useCallback(() => {
        if (bulkSelection.filtersSelection) {
            return;
        }
        addDocumentsToChat(bulkSelection.selected);
        bulkSelection.clearSelection();
    }, [addDocumentsToChat, bulkSelection]);

    if (!canAddToChat || bulkSelection.selectedCount === 0) {
        return null;
    }

    return (
        <AddToChatButton
            noun="document"
            count={bulkSelection.selectedCount}
            onClick={handleAttach}
            disabledReason={
                bulkSelection.filtersSelection
                    ? SELECT_ALL_DISABLED_REASON
                    : undefined
            }
        />
    );
};
